import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Pagination, Navigation, Autoplay } from "swiper/modules"

const CustomCarousel = ({ children, slidesPerView = 1 }) => {
	const slides = React.Children.toArray(children) // handles single, array or direct JSX

	return (
		<div className="w-full max-w-screen-xl mx-auto mt-10 relative group">
			<div className="px-9">
				<Swiper
					slidesPerView={slidesPerView}
					slidesPerGroup={1}
					spaceBetween={20}
					loop={true}
					loopedSlides={slides.length}
					pagination={{ clickable: true }}
					navigation={{
						nextEl: ".next-btn",
						prevEl: ".prev-btn",
					}}
					autoplay={{ delay: 3000 }}
					modules={[Pagination, Navigation, Autoplay]}
					className="mySwiper"
					breakpoints={{
						0: { slidesPerView: 1, spaceBetween: 10 },
						480: { slidesPerView: 1, spaceBetween: 10 },
						640: { slidesPerView: 1, spaceBetween: 15 },
						768: { slidesPerView: 2, spaceBetween: 20 },
						1024: { slidesPerView: slidesPerView, spaceBetween: 30 },
					}}
					simulateTouch={true}
				>
					{slides.map((child, index) => (
						<SwiperSlide key={index}>{child}</SwiperSlide>
					))}
				</Swiper>
			</div>

			{/* Left Button */}
			<button className="prev-btn md:block absolute left-2 top-1/2 transform -translate-y-1/2 text-black z-50 text-3xl md:text-5xl">
				&#8249;
			</button>

			{/* Right Button */}
			<button className="next-btn md:block absolute right-2 top-1/2 transform -translate-y-1/2 text-black z-50 text-3xl md:text-5xl">
				&#8250;
			</button>
		</div>
	)
}

export default CustomCarousel
